module.exports = __webpack_public_path__ + "img/g.2c2d1152.jpg";